const model = {
  state: {
    tabKey: '',
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { dataCustomergroup } }: any) => ({
    changeTabKey(flag) {
      dataCustomergroup.setState({ tabKey: Number(flag) });
    },
  }),
};

export default model;
